const tintClasses = {
  blue: "bg-cerulean/10 text-cerulean",
  azure: "bg-azure/12 text-azure",
  coral: "bg-coral/10 text-coral",
  cobalt: "bg-cobalt/10 text-cobalt",
  teal: "bg-teal/15 text-teal-deep",
};

const sizeClasses = {
  sm: "w-9 h-9 rounded-lg [&>svg]:text-[20px]",
  md: "w-12 h-12 rounded-xl [&>svg]:text-[24px]",
  lg: "w-14 h-14 rounded-2xl [&>svg]:text-[28px]",
};

/**
 * Rounded tinted background square for displaying an icon.
 *
 * @param {Object} props
 * @param {"blue" | "azure" | "coral" | "cobalt" | "teal"} props.tint - background/text color token
 * @param {import("react").ReactNode} props.children - icon element
 * @param {"sm" | "md" | "lg"} [props.size] - chip size, defaults to md
 * @param {string} [props.className] - extra classes
 * @returns {import("react").ReactElement}
 */
export function IconChip(props) {
  const { tint, children, size = "md", className = "" } = props;

  return (
    <span
      className={`inline-flex items-center justify-center ${tintClasses[tint]} ${sizeClasses[size]} ${className}`.trim()}
    >
      {children}
    </span>
  );
}
